import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import { getToken } from 'actions/auth/userToken';
import { withRouter } from 'react-router-dom';
import RaisedButton from 'material-ui/RaisedButton';
import logo from 'assets/images/logo-white.svg';
import { validate } from 'reducers/form/validate';
import { userActions } from 'actions/api/users';
import { Link } from 'react-router-dom';
import { handleError } from 'actions/util/requestUtils';
import { openAlertModal } from 'actions/modals';
import styles from '../styles.scss';
import classnames from 'classnames';
import bgImg from 'assets/images/signup-background.jpg';
import TextField from 'components/util/textField';

class SignUp extends Component {
  signUp = async data => {
    data.password_confirmation = data.password;
    // signup and sign in
    try {
      await this.props.saveUsers({ data, noError: true });
      await getToken({
        data: { email: data.email, password: data.password }
      });
      this.props.history.push('/');
    } catch (e) {
      if (
        e.response.status === 422 &&
        e.response.status &&
        e.response.data &&
        e.response.data.error &&
        e.response.data.error.data &&
        e.response.data.error.data.email
      ) {
        this.props.openAlertModal({
          text: (
            <span>
              Looks like a user with this email already exists. If this is your
              email,{' '}
              <Link to="/sign-in" className="margin-left-sm">
                Sign In
              </Link>
              .
            </span>
          ),
          title: 'Already Signed Up?'
        });
      } else {
        handleError(e);
      }
    }
  };

  render() {
    return (
      <div
        className={styles.wrapper}
        style={{ backgroundImage: `url('${bgImg}')` }}>
        <div className={styles.inner}>
          <div className={styles.header}>
            <img src={logo} className={styles.logo} alt="logo" />
            <div className={styles.subtext}>Translate</div>
          </div>
          <div className={styles.container}>
            <div className={styles.title}>Create an account</div>
            <form
              onSubmit={this.props.handleSubmit(this.signUp)}
              noValidate={true}>
              <div className={styles.inputWrapper}>
                <Field
                  component={TextField}
                  placeholder="Name"
                  name="name"
                  icon="person"
                />
              </div>
              <div className={styles.inputWrapper}>
                <Field
                  component={TextField}
                  placeholder="Email"
                  name="email"
                  type="email"
                  icon="envelope"
                />
              </div>
              <div className={styles.inputWrapper}>
                <Field
                  component={TextField}
                  placeholder="Password"
                  name="password"
                  type="password"
                  icon="lock"
                />
              </div>
              <RaisedButton
                type="submit"
                label="Sign up"
                primary
                fullWidth
                className={styles.marginTopMd}
              />
            </form>
            <div className={classnames(styles.bottomLink)}>
              Have an account? <Link to="/sign-in">Log In</Link>
            </div>
            <div className={classnames(styles.bottomLink, styles.bottomLinkSm)}>
              By signing up, you acknowledge that you have read, understood, and
              agree to the{' '}
              <a
                href="http://www.lodplanner.com/terms"
                target="_blank"
                rel="noopener noreferrer">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const validations = {
  required: {
    fields: ['email', 'password', 'name']
  },
  charCount: { fields: ['password'], min: 8 },
  email: { fields: ['email'] }
};

SignUp = reduxForm({
  form: 'SignUp',
  validate: values => {
    return validate(values, validations);
  }
})(SignUp);

const selector = formValueSelector('SignUp');

function mapStateToProps(state) {
  return {
    email: selector(state, 'email'),
    currentUserId: state.sessionSettings.currentUserId
  };
}

SignUp = withRouter(SignUp);

export default connect(
  mapStateToProps,
  {
    saveUsers: userActions.save,
    openAlertModal
  }
)(SignUp);



// WEBPACK FOOTER //
// ./src/components/auth/signUp/index.js